export default __webpack_public_path__ + "static/home-store-aa662d751abe0469c7f09b0df0ce84f1.png";